"use strict";

module.exports = function () {
    /**
     * Evita que el scroll del mouse modifique
     * el valor del input number
     */
    $("form").on("focus", "input[type=number]", function () {
        $(this).on("wheel.disableScroll", function () {
            $(this).blur();
        });
    });

    /**
     * Evita incremento/decremento
     * con flechas del teclado
     */
    $("form").on("keydown", "input[type=number]", function (e) {
        if (
            e.key === "ArrowUp" ||
            e.key === "ArrowDown"
        ) {
            e.preventDefault();
        }
    });
};